import React from 'react';
import { Link } from 'react-router-dom';
import PrivateLink from './PrivateLink';

const MainLink = (props) => {
  const { isPrivate, contentFor, currentUser, geo, ...remainingProps } = props;

  return isPrivate
    ? <PrivateLink contentFor={contentFor} {...remainingProps} />
    : <Link {...remainingProps} />;
};

export default MainLink;



// WEBPACK FOOTER //
// ./app/components/Link/index.js